import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ token: null, role: null, user: null });
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("jjs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setState({ token, role: data.role, user: data.user });
    } catch {
      localStorage.removeItem("jjs_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = (token, role, user) => {
    localStorage.setItem("jjs_token", token);
    setState({ token, role, user });
  };

  const logout = () => {
    localStorage.removeItem("jjs_token");
    setState({ token: null, role: null, user: null });
  };

  return (
    <AuthContext.Provider value={{ ...state, loading, login, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
